import { render, staticRenderFns } from "./CommunitySettings.vue?vue&type=template&id=a0d77b7e&scoped=true&"
import script from "./CommunitySettings.vue?vue&type=script&lang=ts&"
export * from "./CommunitySettings.vue?vue&type=script&lang=ts&"
import style0 from "./CommunitySettings.vue?vue&type=style&index=0&id=a0d77b7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d77b7e",
  null
  
)

export default component.exports